import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OneDialogModule, OneSnackBarModule } from '@one/angular-kit/modal';
// import { LearnMoreDialogModule } from '@dia/dialog-reusable-components';
// import { RequestAccessDialogModule } from '@dia/dialog-reusable-components';
// import { FeatureFlagModule } from '@dia/dialog-reusable-components';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CookieService } from 'ngx-cookie-service';
// import { MatFileUploadModule } from 'angular-material-fileupload';
import { FileUploadFeatureModule } from '../fileUpload/file-upload.module';
import { OneFilteringChipModule } from '@one/angular-kit/indicator';
import { OneFormFieldModule, OneSelectDropdownModule, OneEditableDropdownModule } from '@one/angular-kit/form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { OneTableModule } from '@one/angular-kit/data-table';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OneIconModule } from '@one/angular-kit/icon';
import { FileUploadService } from '../fileUpload/file-upload/file-upload.service';
import { MatChipsModule } from '@angular/material/chips';
import { OneChipModule } from '@one/angular-kit/indicator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OneTooltipModule } from '@one/angular-kit/modal';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { OneListModule } from '@one/angular-kit/layout';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatMenuModule } from '@angular/material/menu';
import { OneMenuModule } from '@one/angular-kit/navigation';

import { AddOwnTemplateDialogComponent } from './add-own-template-dialog.component';
import { RichTextDocumentFeatureModule } from '../richTextDocument/rich-text-document.module';

// import { FileUploadComponent } from '../fileUpload/file-upload/file-upload.component';
// import { OneEditableDropdown } from '@one/angular-kit/form';

@NgModule({
  declarations: [AddOwnTemplateDialogComponent],
  exports: [AddOwnTemplateDialogComponent],
  imports: [CommonModule, FileUploadFeatureModule, OneIconModule, MatRadioModule, MatAutocompleteModule, RichTextDocumentFeatureModule, MatTooltipModule, OneTooltipModule, OneEditableDropdownModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, OneFormFieldModule, OneSelectDropdownModule, OneFilteringChipModule, MatCardModule, MatChipsModule, OneChipModule, MatIconModule, MatButtonModule, OneSnackBarModule, /*LearnMoreDialogModule, RequestAccessDialogModule, FeatureFlagModule,*/ OneTableModule, MatTableModule, CdkTableModule, MatCheckboxModule, MatSortModule, OneDialogModule, MatDialogModule, MatSelectModule, MatListModule, OneListModule, DragDropModule, MatMenuModule, OneMenuModule],
  providers: [CookieService, FileUploadService]
})
export class AddOwnTemplateDialogModule {}
